import React from "react";
import {CustomInput} from "reactstrap";
import get from 'lodash/get';
import {useTranslation} from "react-i18next";


const CheckboxField = (props) => {
    const {t, i18n} = useTranslation();

    const myOnChange = (event) => {
        props.onChange(event.target.checked);
    };

    if (props.formData !== true && props.formData !== false) {
        props.onChange(false);
    }

    const description = t(props.schema.description) || props.uiSchema['ui:description'];
    return <div className="checkbox">
        <CustomInput
            type="checkbox"
            id={get(props.idSchema, '$id')}
            checked={props.formData}
            readOnly={get(props.uiSchema, 'ui:readonly')}
            onChange={myOnChange}
            label={
                <>
                    {t(get(props.schema, 'title'))}
                    {(props.schema.title && props.required) ? ' *' : ''}
                </>
            }
        />
        <small className="form-text text-muted mb-3 mt-2">
            {description}
        </small>
    </div>;
};

export default CheckboxField;
